"use client";

import { Check } from "@/app/components/Icons/Phosphoricons";
import GetStartedButton from "@/app/components/Utils/GetStartedButton";
import React from "react";

const includedFeatures = [
    // Hosting
    'Migrate Website',
    'Domain Routing',
    'Edge Content Delivery',
    'SSL Security Certificates',
    'Custom Domain',
    'Enterprise AWS Infrastructure',
    'DDOS Bot Protection',
    'Middleware',

    // Business Solutions
    'Email domain MyEmail@MyBusiness.com',
    'Business phone line AWS Connect',

    // Custom Website
    'Custom Website',
    'Unlimited Edits',
    'Unlimited Updates',
    'Mobile Optimized',
    'SEO Optimized',
    'Sell products and services',
    'Database',
    'Storage',
    'Forms',
    'Back End Development',
    'DevOps/DevSecOps Development',
    'Optimized Images & Videos',

    // Reporting
    'Advanced Analytics',
    'Custom Reports',

    // Support
    '24/7 Online Support',
    'DevOps/DevSecOps',
    'Ticket Dashboard',
    'SLA Options',
    'Dedicated Account Manager',

    // Integration
    'AI Development',
    'Third Party API',
    'Custom API Development',
    'Payment Integration',
    'AWS Connect',
    'Chat Pods',
    'Automated Scheduling',

    // Cyber Security
    '24/7 Security Monitoring',
    '24/7 Security Infrastructure Updates',
    '24/7 Security Website Updates',


    'And More!',
];

export default function SimplifiedPricing() {
    return (
        <div className="bg-white py-36 sm:py-48">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-4xl sm:text-center">
                    <h2 className="text-base font-semibold text-blue-600 font-system">Pricing</h2>
                    <h2 className="text-5xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-6xl sm:text-balance">
                        Simple pricing for your business
                    </h2>
                    <p className="mx-auto mt-6 max-w-2xl text-lg font-medium text-pretty text-gray-600 sm:text-xl/8 font-system">
                        100% Veteran Owned | 100% American Made | 100% Data stored in America | No contracts | No hidden
                        fees | No money up front
                    </p>
                    <p className="mx-auto mt-6 max-w-2xl text-lg font-medium text-pretty text-gray-600 sm:text-xl/8 font-system">
                        One stop shop for all your tech needs. So you can focus on your business.
                    </p>
                </div>

                <div className="mx-auto mt-4 max-w-3xl rounded-lg bg-blue-50 p-4 border border-blue-200 shadow-sm">
                    <p className="text-center text-lg font-medium text-blue-700 font-system">
                        <span className="font-bold">Special Spring Offer:</span> Switch to us and get a free website
                        creation up to 10 pages. Migrate your existing website and receive a complimentary design and optimization overhaul!
                    </p>
                </div>

                <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:max-w-none">
                    <div className="p-8 sm:p-10">
                        <div className="lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5">
                            <div>
                                <h3 className="text-3xl font-semibold tracking-tight text-gray-900">Business
                                    Website</h3>
                                <p className="mt-6 text-base/7 text-gray-600">
                                    A comprehensive website solution that grows seamlessly with your business from early
                                    vision to enterprise scale.
                                </p>
                                <p className="mt-6 text-base/7 text-gray-600">
                                    Personal Account Manager
                                </p>
                                <p className="mt-6 text-base/7 text-gray-600">
                                    All work and data stored in America
                                </p>
                            </div>

                            <div className="mt-8 lg:mt-0">
                                <div
                                    className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-gray-900/5 lg:py-12">
                                    <div className="px-8">
                                        <p className="text-base font-semibold text-gray-600">Monthly</p>
                                        <p className="mt-6 flex items-baseline justify-center gap-x-2">
                                            <span className="text-5xl font-semibold tracking-tight text-gray-900">$100</span>
                                            <span className="text-sm/6 font-semibold tracking-wide text-gray-600">/month</span>
                                        </p>
                                        <div className="mt-2 flex justify-center">
                                            <GetStartedButton/>
                                        </div>
                                        <p className="mt-6 text-xs/5 text-gray-600">
                                        Transparent pricing with no long term contracts required
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-12">
                            <div className="flex items-center gap-x-4">
                                <h4 className="flex-none text-sm/6 font-semibold text-blue-600">What's included</h4>
                                <div className="h-px flex-auto bg-gray-100" />
                            </div>
                            <ul role="list" className="mt-8 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6">
                                {includedFeatures.map((feature) => (
                                    <li key={feature} className="flex gap-x-3 min-h-10 items-start">
                                        <Check weight="bold" aria-hidden="true" className="h-6 w-5 flex-none text-blue-600 mt-0.5" />
                                        <span className="flex-1">{feature}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}